import { Card, useTheme } from '@mui/material';
import { H5 } from 'components/Typography';
import Chart from 'react-apexcharts';

const ParticipantSummary = ({ data }) => {
    const { paidInvoice, unPaidParticipant } = data;

    const theme = useTheme();

    const chartOptions = {
        colors: [theme.palette.secondary.main, theme.palette.primary.main],
        chart: {
            stacked: false,
            background: 'transparent',
            sparkline: {
                enabled: true,
            },
            fontFamily: theme.typography.fontFamily,
            events: {
                dataPointMouseEnter: (e) => {
                    if (e && e.target) e.target.style.cursor = 'pointer';
                },
                dataPointMouseLeave: (e) => {
                    if (e && e.target) e.target.style.cursor = 'default';
                },
            },
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '60%',
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            showAlways: true,
                            label: 'Total',
                            fontSize: '30px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 600,
                            color: theme.palette.text.primary,
                            formatter: function (w) {
                                return w.globals.seriesTotals.reduce((a, b) => {
                                    return a + b;
                                }, 0);
                            },
                        },
                    },
                },
            },
        },
        states: {
            normal: {
                filter: {
                    type: 'none',
                },
            },
            hover: {
                filter: {
                    type: 'none',
                },
            },
            active: {
                filter: {
                    type: 'none',
                },
            },
        },
        labels: ['Not Yet Purchased', 'Already Purchased'],
        theme: {
            mode: theme.palette.mode,
        },
        legend: {
            show: true,
            position: 'bottom',
            fontSize: '13px',
            fontWeight: 500,
            itemMargin: {
                horizontal: 10,
            },
            onItemClick: {
                toggleDataSeries: false,
            },
            onItemHover: {
                highlightDataSeries: false,
            },
            offsetY: 0,
        },
        tooltip: {
            theme: 'light',
            style: {
                fontSize: '13px',
            },
            fillSeriesColor: false,
        },
        stroke: {
            width: 0,
        },
    };

    return (
        <Card sx={{ padding: 3, height: '100%' }}>
            <H5 mb={3} textAlign="center">
                Registration Participant Summary
            </H5>

            <Chart
                height={370}
                type="donut"
                options={chartOptions}
                series={[unPaidParticipant, paidInvoice]}
            />
        </Card>
    );
};

export default ParticipantSummary;
